import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import BackButton from '@/components/BackButton.vue';
import VueMarkdown from 'vue-markdown';
const starshipModificationsModule = namespace('starshipModifications');
let StarshipsModifications = class StarshipsModifications extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = this.isInBook ? 'Modifications | Starships' : 'Starship Modifications';
    }
    created() {
        this.fetchStarshipModifications();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.starshipModifications)
            .map(starshipModifications => ({
            ...starshipModifications,
            id: starshipModifications.name,
            isExpandable: starshipModifications.content
        })).value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Type',
                value: 'type',
                filterChoices: ['Engineering', 'Operation', 'Suite', 'Universal', 'Weapon'],
                isMultiSelect: true,
                filterFunction: ({ type }, filterValue) => _.some(filterValue, (filter) => filter === type)
            },
            {
                text: 'Prerequisites',
                value: 'prerequisites',
                render: (prerequisites) => _.upperFirst(prerequisites.join(', ') || '-')
            }
        ];
    }
};
__decorate([
    starshipModificationsModule.State
], StarshipsModifications.prototype, "starshipModifications", void 0);
__decorate([
    starshipModificationsModule.Action
], StarshipsModifications.prototype, "fetchStarshipModifications", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], StarshipsModifications.prototype, "isInBook", void 0);
StarshipsModifications = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], StarshipsModifications);
export default StarshipsModifications;
